import { FormControl } from '@angular/forms';
import { Classroom } from '@models/classroom';
import { SchoolLicense } from '@models/license/school-license';
import { IPrintableReportHeading } from '@models/report-print-heading';
import { Topic } from '@models/topic';
import { BrandedReportsHelpers } from './branded-reports-helpers';


export namespace BrandedReportsPrintHelpers {

  export function getClassOverTimePrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    viewGroupControl: FormControl,
    viewGroupOptions: { value: string, label: string }[],
  ): IPrintableReportHeading[] {
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedGroup = viewGroupControl.value;
    const matchingGroupLabel = BrandedReportsHelpers.findGroupLabelByValue(viewGroupOptions, selectedGroup);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'View',
        value: matchingGroupLabel ?? '',
      },
    ];
  }

  export function getClassSkillsHeatmapAndSpreadPrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    activityIdControl: FormControl,
    topics: Topic[],
    viewGroupControl: FormControl,
    viewGroupOptions: { value: string, label: string }[],
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);
    const selectedTopic = activityIdControl.value;
    const matchingTopic = BrandedReportsHelpers.findTopicByKey(topics, selectedTopic);
    const selectedGroup = viewGroupControl.value;
    const matchingGroupLabel = BrandedReportsHelpers.findGroupLabelByValue(viewGroupOptions, selectedGroup);

    return [
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },
      {
        label: 'Test',
        value: matchingTopic?.topicName ?? ''
      },
      {
        label: 'View',
        value: matchingGroupLabel ?? '',
      },
    ];
  }

  export function getIndividualStudentPrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    studentName: string,
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Student',
        value: studentName ?? ''
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },

    ];
  }

  export function getSkillAveragePrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    skillControl: FormControl,
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Grade',
        value: matchingProduct?.variantDescription ?? ''
      },
      {
        label: 'Skill',
        value: skillControl.value ?? ''
      },
    ];
  }

  export function getStandardsOverTimePrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    skill: FormControl,
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Skill',
        value: skill?.value ?? ''
      },
    ];
  }
}
